import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { ContactService, MemberQuery, ModelDisplay, ModelMetaData, PropertyTypeCode } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { ModelFormHelperService } from '@fgb/portal-component-library/src/lib/shared/forms/model-meta-data-form';

@Component({
  selector: 'fgb-rewards-shipping-page',
  templateUrl: './rewards-shipping-page.component.html',
  styleUrls: ['./rewards-shipping-page.component.scss'],
})
export class RewardsShippingPageComponent implements OnInit {
  screenType = ScreenType;
  models: ModelMetaData[] = [
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 0,
      PropertyName: 'FirstName',
      PropertyTypeCode: PropertyTypeCode.String,
      Validate: true,
      ValidateExpression: "^[a-zA-Z ,.'-]+$"
    },
    
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 1,
      PropertyName: 'Surname',
      PropertyTypeCode: PropertyTypeCode.String,
      Validate: true,
      ValidateExpression: "^[a-zA-Z ,.'-]+$"
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 2,
      PropertyName: 'Street',
      PropertyTypeCode: PropertyTypeCode.String,
      Validate: true,
      ValidateExpression: "[A-Za-zÀ-ÖØ-öø-ÿ0-9.,'-()\\s]+"
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 3,
      PropertyName: 'Town',
      PropertyTypeCode: PropertyTypeCode.String,
      Validate: true,
      ValidateExpression: "^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:[\\s-][A-Za-zÀ-ÖØ-öø-ÿ]+)*$"
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 4,
      PropertyName: 'Country',
      PropertyTypeCode: PropertyTypeCode.Country,
      Validate: false,
      ValidateExpression: null
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 5,
      PropertyName: 'County',
      PropertyTypeCode: PropertyTypeCode.Region,
      Validate: false,
      ValidateExpression: null
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 6,
      PropertyName: 'PostCode',
      PropertyTypeCode: PropertyTypeCode.PostCode,
      Validate: true,
      ValidateExpression: "^[A-Za-z0-9\\s-]{3,10}$"
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 7,
      PropertyName: 'HomeNumber',
      PropertyTypeCode: PropertyTypeCode.String,
      Validate: false,
      ValidateExpression: null
    },
    {
      DisplayStatus: ModelDisplay.Half,
      IsRequired: true,
      Ordinal: 8,
      PropertyName: 'PaymentMethod',
      PropertyTypeCode: PropertyTypeCode.Option,
      Validate: false,
      ValidateExpression: null,
      Options: [
        { label: 'rewards.shipping.payment.method.default', value: 'default' },
        { label: 'rewards.shipping.payment.method.contact.me', value: 'contactme' }
      ]
    }
  ];
  shippingForm: FormGroup;
  isSuccess = false;
  isError = false;
  private destoryRef = inject(DestroyRef);

  constructor(private modelForm: ModelFormHelperService, private memberQuery: MemberQuery, private contactService: ContactService) {}

  ngOnInit() {
    this.memberQuery.selectMemberDetails()
      .pipe(takeUntilDestroyed(this.destoryRef))
        .subscribe(memberDetails => {
          this.shippingForm = this.modelForm.buildForm(this.models, memberDetails);
      });
  }

  submit(): void{
    this.isSuccess, this.isError = false;
    this.shippingForm.markAllAsTouched();

    if( this.shippingForm.valid){
      const message = { 
        category: 'shipping form',
        message: JSON.stringify(this.shippingForm.value)
      };
      this.contactService.sendMessage(message)
      .then(() => {
        this.isSuccess = true;
      }).catch(() => {
        this.isError = true;
      });
    }
  }
}
